/** */
import { urls } from 'services/_url';
import { apiGet, apiPost, apiPut } from 'services/_http';

/** */
const base_url = `${urls.agents}/v1/content-jobs`;
const agent_url = `${urls.agents}/v1/agent`;

export const read = async (options = {}) => {
  return await apiGet(`${base_url}`, { ...options });
};

export const readById = async (id, options = {}) => {
  return await apiGet(`${base_url}/${id}`, { ...options });
};

export const readByBlog = async (blog_id, options = {}) => {
  return await apiGet(`${base_url}/blog/${blog_id}`, { ...options });
};

export const readVersions = async (id, options = {}) => {
  return await apiGet(`${base_url}/${id}/versions`, { ...options });
};

export const search = async (keys, keyword, options = {}) => {
  const query_string = options.query_string
    ? `${options.query_string}&keyword=${keyword}`
    : `keyword=${keyword}`;
  return await apiGet(`${base_url}/search/${keys}`, {
    ...options,
    query_string
  });
};

export const accept = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}/approve`, { ...options });
};

export const reject = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}/reject`, { ...options });
};

export const saveEdit = async (id, options = {}) => {
  return await apiPut(`${base_url}/${id}/edit`, { ...options });
};

export const triggerRun = async (agent_type, options = {}) => {
  return await apiPost(`${agent_url}/content/${agent_type}/run`, { ...options });
};
